import { useEffect, useState } from 'react';
import { useKiosk } from './kiosk';
import { OwnedObjectType } from '../app/components/Inventory/OwnedObjects';

export function useSudoCardSelector(kioskId: string | undefined) {
  const [selected, setSelected] = useState<OwnedObjectType | undefined>();

  const {
    data: kioskData,
    isLoading,
    isError,
    refetch: getKioskData,
  } = useKiosk(kioskId);

  const showSudoCardSelector = kioskData && kioskData.items.length > 1 && selected;

  useEffect(() => {
    // reset when card change
    if (!kioskData?.items.find(x => x.objectId === selected?.objectId))
        setSelected(kioskData?.items[0]);

    if (isLoading || selected) return;
    setSelected(kioskData?.items[0]);
  }, [isLoading, selected, kioskData?.items, setSelected]);

  return {
    selected,
    setSelected,
    showSudoCardSelector,
  };
}
